// extracted by mini-css-extract-plugin
export default {"footer_container":"DocumentsPerProcess_footer_container__31b8c"};